"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.isValidHEX=function(t){return t.startsWith("#")?(t=t.slice(1)).length<=6&&/[A-Fa-f0-9]/.test(t[t.length-1]):/\w/.test(t)&&!/\d/.test(t)||""===t};
